import React, { AnchorHTMLAttributes } from "react"
import { ButtonLink, ButtonLinkProps } from "@indeed/ifl-components"
import { configSelector } from "../../utils/config-slice"
import { useI18n } from "../../utils/i18n-context"
import { useAppSelector } from "../../utils/redux-helpers"

interface BrowseJobsButtonProps extends ButtonLinkProps, AnchorHTMLAttributes<HTMLElement> {}

export const BrowseJobsButton: React.FC<BrowseJobsButtonProps> = ({ onClick, target, variant = "secondary", full, sx, iconAfter }) => {
    const config = useAppSelector(configSelector)
    const { gettext } = useI18n()

    return (
        <ButtonLink
            href={config.jobSearchUrl}
            variant={variant}
            sx={sx}
            full={full}
            onClick={onClick}
            target={target}
            iconAfter={iconAfter}
        >
            {gettext("Find jobs")}
        </ButtonLink>
    )
}
